import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import "../../assets/css/Chat.css";
import Footer from "../../components/Footer";
import { profileImg } from "../../Constant";
import { connect } from "react-redux";
import { GetChatsAction } from "../../redux/actions/chat";
import config from "../../config";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClock,
    faPaperPlane,
    faStar,
} from "@fortawesome/free-solid-svg-icons";
// import { Link, useParams, } from "react-router-dom";
import Pusher from "pusher-js";

const msgsPagination = {
    current_page: null,
    data: [],
    first_page_url: null,
    from: null,
    last_page: null,
    last_page_url: null,
    links: [],
    next_page_url: null,
    path: null,
    per_page: null,
    prev_page_url: null,
    to: null,
    total: null,
};

let pusher = null;
let chatChannel = null;

class AllChat extends React.Component {
    constructor(props) {
        super();

        this.state = {
            talkingTo: {},
            talkingToId: null,
            msgs: { ...msgsPagination },
            message: "",
            loading: true,
        };
    }

    componentDidMount() {
        this.props.getChats().then(() => {
            this.setState({ loading: false });
            setTimeout(() => {
                let url = window.location.href.split("/");
                if (!isNaN(url[url.length - 1])) {
                    this.setState({
                        talkingToId: url[url.length - 1],
                    });
                    this.getMessages();
                    this.props.getChats().then();
                }
            }, 500);
        });
    }

    getMessages = async () => {
        try {
            const headers = config.bearerHeaders(this.props.auth.token);
            const data = JSON.stringify({ user_id: this.state.talkingToId });
            const res = await config.postApi(
                config.services.getMessages(),
                headers,
                data
            );
            if (res) {
                let msgsToUpdate = { ...res.response.data };
                msgsToUpdate.data = [...msgsToUpdate.data].reverse();
                this.setState({ msgs: msgsToUpdate }, this.scroll);
                document.getElementById("customer-chat-messages").onscroll = (
                    e
                ) => {
                    if (e.target.scrollTop == 0) {
                        this.loadMoreMessages();
                    }
                };
            }
        } catch (e) {
            console.log(e);
        }
    };

    loadMoreMessages = async () => {
        try {
            if (this.state.msgs.next_page_url) {
                const headers = config.bearerHeaders(this.props.auth.token);
                const data = JSON.stringify({
                    user_id: this.state.talkingToId,
                });
                const res = await config.postApi(
                    this.state.msgs.next_page_url,
                    headers,
                    data
                );
                if (res) {
                    let newMsgs = {
                        ...res.response.data,
                        data: [
                            ...[...res.response.data.data].reverse(),
                            ...this.state.msgs.data,
                        ],
                    };
                    this.setState({
                        msgs: newMsgs,
                    });
                }
            }
        } catch (e) {
            console.log(e);
        }
    };

    sendMessage = async (e = null) => {
        if (e) {
            e.preventDefault();
        }
        if (this.state.message.trim() == "") {
            return false;
        }
        try {
            const headers = config.bearerHeaders(this.props.auth.token);
            const data = JSON.stringify({
                message_type: "text",
                user_id: this.state.talkingToId,
                message: this.state.message,
            });
            const res = await config.postApi(
                config.services.sendMessage(),
                headers,
                data
            );
            if (res) {
                this.setState({ message: "" });
                let newMessages = { ...this.state.msgs };
                newMessages["data"] = [
                    ...newMessages["data"],
                    res.response.data,
                ];
                this.setState({ msgs: { ...newMessages } }, this.scroll);
                // this.scroll();
            }
        } catch (e) {
            console.log(e);
        }
    };

    scroll = () => {
        document.getElementById("customer-chat-messages").scroll({
            top: document.getElementById("customer-chat-messages").scrollHeight,
            behavior: "smooth",
        });
        // $("#customer-chat-messages").animate(
        //     { scrollTop: $("#customer-chat-messages")[0].scrollHeight },
        //     1000
        // );
        // $("#customer-chat-messages").scrollTop($("#customer-chat-messages")[0].scrollHeight);
    };

    addToMessages = (messageObj) => {
        let newMessages = { ...this.state.msgs };
        newMessages.data = [...newMessages.data, messageObj];
        this.setState({ msgs: { ...newMessages } });
        this.scroll();
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.state.talkingToId != prevState.talkingToId) {
            if (this.state.talkingToId) {
                this.setState({ message: "", msgs: { ...msgsPagination } });
                this.getMessages();
                if (this.pusher == null) {
                    this.pusher = new Pusher(config.pusher.key, {
                        cluster: config.pusher.cluster,
                    });
                }
                if (this.chatChannel) {
                    this.chatChannel.unbind_all();
                }
                this.chatChannel = this.pusher.subscribe("chat");
                this.chatChannel.bind("App\\Events\\ChatEvent", (e) => {
                    if (
                        e.message.receiver_type_id == this.props.auth.user.id &&
                        e.message.sender_type_id == this.state.talkingToId
                    ) {
                        this.addToMessages(e.message);
                    }
                });
            }
        }
    }

    componentWillUnmount() {
        if (this.chatChannel) {
            this.chatChannel.unbind_all();
        }
    }

    render() {
        if (this.state.loading) {
            return <div />;
        }
        return (
            <>
                <Header />
                <section>
                    <div className="container-fluid">
                        <div className="row py-4">
                            <div className="col-md-12 pl-5">
                                <h4 className="blue">My Conversation</h4>
                                <p>
                                    Understand your clients’ needs to provide
                                    better caregiving or home-helping services.
                                    Our chat offers you an opportunity to
                                    connect with the client instantly.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="card rare-wind-gradient chat-room">
                        <div className="card-body">
                            {/* <!-- Grid row --> */}
                            <div className="row px-lg-2 px-2">
                                {/* <!-- Grid column --> */}
                                <div className="col-md-3 col-xl-3 px-0">
                                    <div className="white z-depth-1 px-2 pt-3 pb-0 members-panel-1">
                                        {this.state.talkingTo.id ? (
                                            <div className="active grey lighten-3 p-2 single-chat-list chat-profileContainer">
                                                <a
                                                    id="giverChat_Id"
                                                    // href="#;"
                                                    className="chatprofile-header giverChat_Id1 d-flex  vol"
                                                >
                                                    <img
                                                        src={config.returnImage(
                                                            this.state.talkingTo
                                                        )}
                                                        whidth="100"
                                                        height="100"
                                                        alt="avatar"
                                                        className="giver-picture avatar rounded-circle d-flex align-self-center mr-2 z-depth-1"
                                                    />
                                                    {/* <div className="online"></div> */}
                                                    <div className="text-small pt-3 flex-chatname">
                                                        <strong className="giverChat-name">
                                                            {
                                                                this.state
                                                                    .talkingTo
                                                                    .full_name
                                                            }
                                                        </strong>
                                                    </div>
                                                    <div className="chat-footer pt-3 ml-auto">
                                                        <p className="text-smaller  mb-0">
                                                            <FontAwesomeIcon
                                                                color={
                                                                    config.starActiveColor
                                                                }
                                                                icon={faStar}
                                                            />{" "}
                                                            <span id="rating-by-customer">
                                                                {
                                                                    this.state
                                                                        .talkingTo
                                                                        .rating_by_customer
                                                                }
                                                            </span>
                                                        </p>
                                                    </div>
                                                </a>
                                            </div>
                                        ) : null}
                                        <ul
                                            id="all-chat-talking-to"
                                            className="userChatList scrollbar-light-blue list-unstyled friend-list border-bottom single-chat chat-listuser"
                                        >
                                            {this.props.chat.data.length > 0 ? (
                                                this.props.chat.data.map(
                                                    (singleChat) => {
                                                        if (
                                                            singleChat.talking_to
                                                        ) {
                                                            return (
                                                                <li
                                                                    key={
                                                                        singleChat.id
                                                                    }
                                                                    className="active grey lighten-3 p-2 single-chat-list"
                                                                >
                                                                    <a
                                                                        id={`chat_${singleChat.talking_to.id}`}
                                                                        onClick={() => {
                                                                            this.setState(
                                                                                {
                                                                                    talkingTo:
                                                                                        singleChat.talking_to,
                                                                                    talkingToId:
                                                                                        singleChat
                                                                                            .talking_to
                                                                                            .id,
                                                                                }
                                                                            );
                                                                        }}
                                                                        // id="giverChat_Id"
                                                                        // to={`/all-chat/${singleChat.talking_to.id}`}
                                                                        // to={{
                                                                        //     pathname: `/all-chat/${singleChat.talking_to.id}`,
                                                                        // }}
                                                                        className="giverChat_Id1 d-flex chat-route vol"
                                                                    >
                                                                        <div
                                                                            className="row"
                                                                            style={{
                                                                                width: "100%",
                                                                            }}
                                                                        >
                                                                            <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                                                                                <div className="avatar-container">
                                                                                    <img
                                                                                        src={config.returnImage(
                                                                                            singleChat.talking_to
                                                                                        )}
                                                                                        whidth="100"
                                                                                        height="100"
                                                                                        alt="avatar"
                                                                                        className="giver-picture avatar-chat rounded-circle d-flex align-self-center mr-2 z-depth-1"
                                                                                    />
                                                                                    {/* <div className="online-all"></div> */}
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-lg-7  col-md-7 col-sm-7 col-7">
                                                                                <div className="text-small pt-3">
                                                                                    <strong className="giverChat-name-all">
                                                                                        {
                                                                                            singleChat
                                                                                                .talking_to
                                                                                                .full_name
                                                                                        }
                                                                                    </strong>
                                                                                    <p className="last-message text-muted ">
                                                                                        <span className="giver-country">
                                                                                            {
                                                                                                singleChat.last_message
                                                                                            }
                                                                                        </span>
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                                                                                <div className="chat-footer pt-3 ml-auto">
                                                                                    <p className="text-smaller text-muted mb-0">
                                                                                        {singleChat.last_message_date_time
                                                                                            ? moment(
                                                                                                  singleChat.last_message_date_time
                                                                                              ).fromNow()
                                                                                            : ""}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </li>
                                                            );
                                                        }
                                                    }
                                                )
                                            ) : (
                                                <div
                                                    style={{
                                                        flex: 1,
                                                        justifyContent:
                                                            "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <p>No Chat Found</p>
                                                </div>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                                {/* <!-- Grid column --> */}
                                <div className="col-md-9 col-xl-9 pl-md-3 px-lg-auto px-0">
                                    <form
                                        id="sender-giver"
                                        className="sender-customer"
                                        method=""
                                        action=""
                                        onSubmit={this.sendMessage}
                                    >
                                        <div className="chat-message">
                                            <ul
                                                id="customer-chat-messages"
                                                className="list-unstyled chat-1 chat-helper scrollbar-light-blue customer-chat-messages"
                                            >
                                                {this.state.msgs.data.map(
                                                    (msg) => {
                                                        if (
                                                            msg.sender_type_id !=
                                                            this.props.auth.user
                                                                .id
                                                        ) {
                                                            return (
                                                                <React.Fragment
                                                                    key={msg.id}
                                                                >
                                                                    <li
                                                                        className="justify-content-left"
                                                                        // key={`chat_list_${msg.id}`}
                                                                    >
                                                                        <div className="chat-body white p-3 ml-2 z-depth-1">
                                                                            <p className="mb-0">
                                                                                {
                                                                                    msg.message
                                                                                }
                                                                            </p>
                                                                            <div className="header">
                                                                                {/* <strong className="primary-font">
                                                                                Brad
                                                                                Pitt
                                                                            </strong> */}
                                                                                <small className="pull-right text-muted">
                                                                                    <FontAwesomeIcon
                                                                                        icon={
                                                                                            faClock
                                                                                        }
                                                                                    />{" "}
                                                                                    {moment(
                                                                                        msg.created_at
                                                                                    ).fromNow()}
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <div className="clearfix" />
                                                                </React.Fragment>
                                                            );
                                                        } else {
                                                            return (
                                                                <React.Fragment
                                                                    key={msg.id}
                                                                >
                                                                    <li
                                                                        className="justify-content-right"
                                                                        // key={msg.id}
                                                                    >
                                                                        <div className="chat-body sender-container white p-3 ml-2 z-depth-1">
                                                                            <p className="mb-0">
                                                                                {
                                                                                    msg.message
                                                                                }
                                                                            </p>
                                                                            <div className="header">
                                                                                {/* <strong className="primary-font">
                                                                                Brad
                                                                                Pitt
                                                                            </strong> */}
                                                                                <small className="pull-right text-muted">
                                                                                    <FontAwesomeIcon
                                                                                        icon={
                                                                                            faClock
                                                                                        }
                                                                                    />{" "}
                                                                                    {moment(
                                                                                        msg.created_at
                                                                                    ).fromNow()}
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <div className="clearfix" />
                                                                </React.Fragment>
                                                            );
                                                        }
                                                    }
                                                )}
                                            </ul>
                                            <div className="white">
                                                <div className="d-flex justify-content-start">
                                                    <div className="form-group basic-textarea chat-area col-md-11 col-xs-12 col-sm-12">
                                                        <input
                                                            type="hidden"
                                                            id="message_type"
                                                            value="text"
                                                            className="message_type"
                                                        />
                                                        <button
                                                            id="show-chat-list-btn"
                                                            className="send-chat send-all-chat"
                                                            onClick={
                                                                this.sendMessage
                                                            }
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faPaperPlane
                                                                }
                                                                className="send-chat"
                                                            />
                                                        </button>
                                                        <input
                                                            className="form-control pl-2 my-0 chat-message"
                                                            id="chat-message"
                                                            rows="3"
                                                            placeholder="Type your message here..."
                                                            required
                                                            value={
                                                                this.state
                                                                    .message
                                                            }
                                                            onChange={(e) => {
                                                                this.setState({
                                                                    message:
                                                                        e.target
                                                                            .value,
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    chat: state.chat,
});

const mapDispatchToProps = (dispatch) => ({
    getChats: async () => dispatch(await GetChatsAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllChat);
